import createKeyStore from './create-key-store';

const [useVizDataStore, vizDataStore] = createKeyStore({});

export { useVizDataStore, vizDataStore };
